import { SVGProps } from 'react';

const SendScaleLargeAppearanceOutlined = (props: SVGProps<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M16.0001 17.9994V25.3328M16.3887 25.4456L25.6883 28.5589C26.4189 28.8034 26.7842 28.9257 27.0092 28.838C27.2045 28.7618 27.3526 28.5981 27.409 28.3961C27.4739 28.1635 27.3158 27.8122 26.9997 27.1097L16.9728 4.8277C16.6642 4.14193 16.5099 3.79904 16.2955 3.69306C16.1093 3.60099 15.8908 3.60099 15.7046 3.69306C15.4902 3.79904 15.3359 4.14193 15.0273 4.8277L4.99702 27.1174C4.68182 27.8179 4.52421 28.1681 4.58886 28.4005C4.64501 28.6022 4.79273 28.7659 4.98772 28.8424C5.21224 28.9304 5.57675 28.8095 6.30575 28.5675L15.7141 25.4448C15.8393 25.4032 15.9019 25.3824 15.9659 25.3742C16.0228 25.367 16.0803 25.367 16.1371 25.3745C16.2011 25.3828 16.2636 25.4038 16.3887 25.4456Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2.66667}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default SendScaleLargeAppearanceOutlined;
